<div class="container">
  <!-- Initial Transaction Details -->
  <div class="transaction-info">
    <p><strong>Reference:</strong> {{ transactionId }}</p>
  </div>

  <!-- Loading State -->
  <div *ngIf="transactionStatus === 'loading'" class="loading">
    <mat-spinner></mat-spinner>
    <p>Verifying transaction...</p>
  </div>

  <!-- Success State -->
  <div *ngIf="transactionStatus === 'success'" class="success">
    <mat-icon color="primary" class="icon-size">check_circle</mat-icon>
    <h2>Payment Successful!</h2>
    <p>Your transaction was completed successfully.</p>
    <button (click)="goBack()" class="bg-zestGreen text-white rounded-lg py-4 px-20 w-full">Go to Store</button>
  </div>

  <!-- Failure State -->
  <div *ngIf="transactionStatus === 'failure'" class="failure">
    <mat-icon color="warn" class="border border-red-500 icon-size ">cancel</mat-icon>
    <h2>Payment Failed!</h2>
    <p>Unfortunately, your payment could not be processed.</p>
    <button (click)="goBack()" class="bg-zestGreen text-white rounded-lg py-4 px-20 w-full">Go to Store</button>
  </div>

  <!-- Pending State -->
  <div *ngIf="transactionStatus === 'pending'" class="pending">
    <mat-icon class=" border border-red-500 icon-size">hourglass_empty</mat-icon>
    <h2>Payment Pending...</h2>
    <p>We are still verifying your transaction. Please wait.</p>
  </div>

  <!-- Cancelled State -->
  <div *ngIf="transactionStatus === 'cancelled'" class="cancelled icon-size">
    <mat-icon color="accent">cancel</mat-icon>
    <h2>Transaction Cancelled</h2>
    <p>You cancelled the transaction.</p>
    <button (click)="goBack()" class="bg-zestGreen text-white rounded-lg py-4 px-20 w-full">Go to Store</button>
  </div>

  <!-- Expired State -->
  <div *ngIf="transactionStatus === 'expired'" class="expired icon-size">
    <mat-icon color="warn">hourglass_disabled</mat-icon>
    <h2>Transaction Expired</h2>
    <p>Your transaction has expired. Please try again.</p>
    <button (click)="goBack()" class="bg-zestGreen text-white rounded-lg py-4 px-20 w-full">Go to Store</button>
  </div>
</div>
